import { render, staticRenderFns } from "./EditHistoryTableViewer.vue?vue&type=template&id=1878b27a&scoped=true&"
import script from "./EditHistoryTableViewer.vue?vue&type=script&lang=ts&"
export * from "./EditHistoryTableViewer.vue?vue&type=script&lang=ts&"
import style0 from "./EditHistoryTableViewer.vue?vue&type=style&index=0&id=1878b27a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1878b27a",
  null
  
)

export default component.exports